import React, { useState, useEffect } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import KpiTable from './KpiTable';
import { BaseTableRQ } from 'components/common/models/BaseClass';
import { search } from 'services/bs-kpi-board/kpiBoardService';
import PropTypes from 'prop-types';
import KpiTableHeader from './KpiTableHeader';
import { usePaginationBe } from 'hooks/useBeHandle';
import KpiModal from './KpiModal';

const RunningKPI = ({ pageSize = 10 }) => {
  const defaultRQ = { ...new BaseTableRQ(1, pageSize) };
  const [filter, setFilter] = useState({});
  const [kpis, setKpis] = useState([]);
  const [total, setTotal] = useState(0);
  const [paging, setPaging] = useState({ ...defaultRQ });
  const [isFilter, setIsFilter] = useState(false);
  // const [colSort, setColSort] = useState(undefined);
  const [isModal, setIsModal] = useState(false);
  const [dataModal, setDataModal] = useState({});

  const loadKpis = pagingRq => {
    search(pagingRq)
      .then(res => {
        if (res) {
          setKpis(res.items);
          setTotal(res.total);
          let cl = {
            ...pagingRq,
            sortBy: pagingRq.sortBy,
            desc: pagingRq.desc,
            isBeSortedDesc: pagingRq.desc,
            isBeSorted: pagingRq.sortBy != undefined && pagingRq.sortBy != ''
          };
          // setColSort(cl);
          setPaging(cl);
          setFilter(cl);
        }
      })
      .catch(err => {
        console.log(err);
      });
    setPaging(pagingRq);
  };

  const defaultPaging = data => {
    return {
      ...data,
      pageNum: defaultRQ.pageNum,
      pageSize: defaultRQ.pageSize,
      isLike: defaultRQ.isLike,
      isGetAll: defaultRQ.isGetAll
    };
  };

  useEffect(() => {
    setIsFilter(false);
    // getConfig();
    loadKpis(defaultPaging);
  }, []);

  const toggelFilter = () => {
    setIsFilter(!isFilter);
  };

  const toggelModal = () => {
    setIsModal(!isModal);
  };
  const handleCloseModal = () => {
    setIsModal(false);
    setDataModal({});
  };
  const handleSubmitModal = () => {
    handleCloseModal();
    loadKpis(defaultPaging);
  };

  const { gotoPage, nextPage, previousPage } = usePaginationBe(
    paging,
    total,
    loadKpis,
    filter,
    setFilter
  );

  // const { getConfig, saveConfig } = useHanleConfig(
  //   KEY_MEETING_LIST_CONFIG,
  //   filter,
  //   mapRQData,
  //   defaultRQ,
  //   defaultPaging,
  //   loadKpis
  // );

  return (
    <>
      <Card>
        <Row style={{ padding: '10px' }}>
          <KpiTableHeader
            toggelFilter={() => toggelFilter()}
            toggelModal={() => toggelModal()}
            // handleSearch={handleSeach}
            style={{ padding: '10px' }}
          />
          {/* {isFilter && (
            <Col lg={12} style={{ paddingBottom: '10px', paddingTop: '10px' }}>
              <MeetingFilter
                displayOption={{
                  showHeader: true,
                  showFooter: true,
                  col: '3'
                }}
                style={{
                  paddingBottom: '10px',
                  maxHeight: '250px',
                  overflowY: 'auto'
                }}
                handleChange={handleChange}
                formData={filter}
                handleSubmit={handleSubmit}
                saveConfig={saveConfig}
              />
            </Col>
          )} */}
          <Col lg={isFilter ? 9 : 12}>
            <KpiTable
              data={kpis}
              paging={paging}
              total={total}
              nextPage={nextPage}
              previousPage={previousPage}
              gotoPage={gotoPage}
              handleClickRow={(e, row) => {
                if (row) {
                  setDataModal(row.original);
                  setIsModal(true);
                }
              }}
              // colSort={colSort}
              // handleSort={handleSort}
            />
          </Col>
        </Row>
        <KpiModal
          isShow={isModal}
          handleClose={handleCloseModal}
          data={dataModal}
          handleSubmit={handleSubmitModal}
        />
      </Card>
    </>
  );
};

RunningKPI.propTypes = {
  pageSize: PropTypes.number
};

export default RunningKPI;
